module.exports = __webpack_public_path__ + "fonts/nationale-regular.1a41e0b.otf";